import { ref, computed, onBeforeUnmount } from 'vue';
import { timeFormatter } from '@/helpers/timeFormatter';
import {getInitialExtensionTime, getInitialTime} from "@/util/timeUtils";
import useAnimationFrame from '@/composables/base/useAnimationFrame'

export function useTimer(isExtension = true) {
    const timerState = ref (0)
    const getTime = isExtension? getInitialExtensionTime : getInitialTime
    let animationFramePause = null

    const timerOptions = ref({
        realtime: false,
    });

    const timerDisplayTime = computed(() => {
        return timeFormatter(timerState.value, timerOptions.value.realtime);
    });

    const startTimer = (data, settings) => {
        const { pause } = useAnimationFrame(
            () => {
                timerState.value = getTime(data.value, settings)
            }
        )

        animationFramePause = pause
    }

    const stopTimer = () => {
        if (animationFramePause) {
            animationFramePause()
        }
    }

    onBeforeUnmount(() => {
        stopTimer()
    })

    return {
        timerDisplayTime,
        timerState,
        startTimer,
        stopTimer
    }
}
